import React from 'react';
import Reveal from './Reveal';

/** Team-Sektion: Schwarz-Weiß-Portraits im Raster */
const team = [
  { name: 'Jules', image: '/team/jules.jpg' },
  { name: 'Mido', image: '/team/mido.jpg' },
  { name: 'Frank River', image: '/team/frank.jpg' },
  { name: 'Abih Lite', image: '/team/abih.jpg' },
  { name: 'Claudius', image: '/team/andi.jpg' },
];

export default function TeamSection({ content = {} }) {
  const kicker = content?.team_kicker || 'Das Team';
  const headline = content?.team_headline || 'DIE MENSCHEN\nDAHINTER.';

  return (
    <section className="section-padding bg-background" id="team">
      <div className="container-custom">
        <div className="mb-14">
          <Reveal>
            <span className="kicker mb-6 inline-flex">{kicker}</span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[0.9] text-foreground">
              {headline.split('\n').map((line, i) => (
                <span key={i} className="block">{line.trim()}</span>
              ))}
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {team.map((member, index) => (
            <Reveal key={member.name} delay={index * 0.08}>
              <figure className="group relative overflow-hidden bg-ink">
                <img
                  src={member.image}
                  alt={member.name}
                  loading="lazy"
                  className="w-full aspect-[3/4] object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
                <figcaption className="absolute bottom-0 left-0 right-0 p-4">
                  <span className="font-display text-2xl md:text-3xl text-white uppercase">
                    {member.name}
                  </span>
                  <span className="block h-1 w-0 bg-yellow mt-2 transition-all duration-500 group-hover:w-10" />
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
